/* eslint-disable react-hooks/exhaustive-deps */
import Header from 'components/header';
import PageWrapper from 'components/pageWrapper';
import styles from 'styles/components/myCyclesDetails.module.scss';
import { useParams, useSearchParams } from 'react-router-dom';
import { getMyCycleById } from 'services/api/my/cycles';
import { useContext, useEffect, useState } from 'react';
import { Avatar, Breadcrumb, Spin, Tabs, Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  HomeOutlined,
  LoadingOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { REVIEW_VISIBILITY } from 'utils/constants';
import ProfileContext from 'services/profileContext';
import ConfettiExplosion from 'react-confetti-explosion';
import CycleDetailsRender from 'components/cycleDetailsRender';
import CycleDetailsReadOnlyRender from 'components/cycleDetailsReadOnlyRender';
import { listMyReviewees } from 'services/api/cycles';

const MyCycle = () => {
  const { myCycleId } = useParams();
  const [loading, setLoading] = useState(false);
  const [cycle, setCycle] = useState(null);
  const { profile } = useContext(ProfileContext);
  const [isConfettiExploding, setIsConfettiExploding] = useState(false);
  const [tabsManager, setTabsManager] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  // const [reviewLoading, setReviewLoading] = useState(false);
  const showConfettis = () => {
    setIsConfettiExploding(true);
  };

  const fetchCycle = () => {
    setLoading(true);
    return Promise.all([
      getMyCycleById({
        cycleId: myCycleId,
      }),
      listMyReviewees({
        cycleId: myCycleId,
      }),
    ])
      .then(([{ data: cycleData }, { data: revieweesData }]) => {
        const tasksPerModule = cycleData.tasks.reduce((acc, task, index) => {
          acc[task.type] = [
            ...(acc[task.type] || []),
            { ...task, originalIndex: index, internalKey:  `${task?.user?._id}-${task?.type}` },
          ];
          return acc;
        }, {});

        const reviewsPerModule = cycleData.reviews.reduce(
          (acc, task, index) => {
            acc[task.type] = [
              ...(acc[task.type] || []),
              { ...task, originalIndex: index, internalKey:  `${task?.user?._id}-${task?.type}` },
            ];
            return acc;
          },
          {}
        );

        setCycle({
          ...cycleData,
          tasks: cycleData.tasks.map((t) => ({...t, internalKey:  `${t?.user?._id}-${t?.type}`})),
          reviews: cycleData.reviews.map((r) => ({...r, internalKey:  `${r?.user?._id}-${r?.type}`})),
          tasksPerModule,
          reviewsPerModule,
        });

        const t = revieweesData.map((reviewee) => ({
          reviews: reviewee.reviews.map((r, i) => ({
            ...r,
            id: `${i}-${r.from._id}-${r.type}`,
          })),
          user: reviewee.user,
          label: (
            <div>
              <Avatar
                src={reviewee?.user?.profile?.profilePictureUrl}
                icon={<UserOutlined />}
                size={24}
                style={{ marginRight: 8 }}
              />
              {reviewee.user.profile.firstName} &nbsp;
              {reviewee.user.profile.lastName}
              {cycleData?.reviewVisibility ===
                REVIEW_VISIBILITY.MANAGER_RELEASE &&
                reviewee.reviews.length > 0 && (
                  <>
                    {reviewee.reviews.some(
                      (review) => review.status === 'READY'
                    ) ? (
                      <Tag style={{ marginLeft: 8 }} color="orange">
                        <WarningOutlined />
                      </Tag>
                    ) : reviewee.reviews.every(
                        (review) => review.status === 'DONE'
                      ) ? (
                      <Tag style={{ marginLeft: 8 }} color="green">
                        <CheckCircleOutlined />
                      </Tag>
                    ) : (
                      <Tag style={{ marginLeft: 8 }} color="purple">
                        <ClockCircleOutlined />
                      </Tag>
                    )}
                  </>
                )}
            </div>
          ),
          id: reviewee?.user?._id,
        }));
        setTabsManager(t.filter((t) => t.id !== profile._id));

      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCycle();
  }, []);

  return (
    <>
      <Header width={1320} />
      {isConfettiExploding && (
        <div style={{ position: 'fixed', top: 0, left: '45%' }}>
          <ConfettiExplosion
            particleCount={300}
            onComplete={() => {
              setIsConfettiExploding(false);
            }}
          />
        </div>
      )}
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined spin style={{ fontSize: 44 }} />}
      >
        <PageWrapper width={1380}>
          <div className={styles.content}>
            <div className={styles.inner}>
              <Breadcrumb
                items={[
                  {
                    title: (
                      <div>
                        <HomeOutlined /> My Cycles
                      </div>
                    ),
                    href: '/#/my/cycles',
                  },
                  { title: cycle?.name },
                ]}
              />
              {cycle && (
                <div className={styles.cycleDetails}>
                  {tabsManager && tabsManager.length > 0 ? (
                    <div className={styles.tabsManager}>
                      <Tabs
                        style={{ width: '100%' }}
                        type="card"
                        activeKey={searchParams.get('userId') || profile._id}
                        onChange={(key) => {
                          if (key !== profile._id) {
                            setSearchParams((prev) => {
                              prev.set('reviewIndex', 0);
                              prev.set('userId', key);
                              return prev;
                            });
                          } else {
                            setSearchParams((prev) => {
                              prev.delete('userId');
                              prev.set('reviewIndex', 0);
                              return prev;
                            });
                          }
                        }}
                        items={[
                          {
                            key: profile._id,
                            label: (
                              <div>
                                <Avatar
                                  src={profile.profile.profilePictureUrl}
                                  icon={<UserOutlined />}
                                  size={24}
                                  style={{ marginRight: 8 }}
                                />
                                {profile.profile.firstName}
                                &nbsp;(You)
                              </div>
                            ),
                            children: (
                              <CycleDetailsRender
                                cycle={cycle}
                                showConfettis={showConfettis}
                                setCycle={setCycle}
                                fetchCycle={fetchCycle}
                                myCycleId={myCycleId}
                                // contextReviews={contextReviews}
                              />
                            ),
                          },
                          ...(tabsManager.length > 0
                            ? tabsManager.map((tab) => ({
                                key: tab.id,
                                label: tab.label,
                                children: (
                                  <CycleDetailsReadOnlyRender
                                    user={tab.user}
                                    reviews={tab.reviews}
                                    callbackFetch={fetchCycle}
                                    cycle={cycle}
                                    showConfettis={false}
                                    setCycle={setCycle}
                                    fetchCycle={fetchCycle}
                                    myCycleId={myCycleId}
                                  />
                                ),
                              }))
                            : []),
                        ]}
                      />
                    </div>
                  ) : (
                    <CycleDetailsRender
                      cycle={cycle}
                      showConfettis={showConfettis}
                      setCycle={setCycle}
                      fetchCycle={fetchCycle}
                      myCycleId={myCycleId}
                      // contextReviews={contextReviews}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </PageWrapper>
      </Spin>
    </>
  );
};

export default MyCycle;
